import { render } from "./ActionsView.vue?vue&type=template&id=130f7a46&scoped=true"
import script from "./ActionsView.vue?vue&type=script&lang=js"
export * from "./ActionsView.vue?vue&type=script&lang=js"

import "./ActionsView.vue?vue&type=style&index=0&id=130f7a46&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-130f7a46"]])

export default __exports__